const validate = (values) => {
    const errors = {};

    if (!values.databaseName) {
        errors.databaseName = 'Please enter database name';
    }
    if (!values.serverName ) {
        errors.serverName = 'Please enter server name';
    }
    if (!values.userName) {
        errors.userName = 'Please enter user name';
    }
    if (!values.password) {     
        errors.password = 'Please enter password';
    }
    if (values.confirmPassword !== values.password) {
        errors.confirmPassword = 'Password mismatched';
    }
    return errors;
};

export default validate;


// WEBPACK FOOTER //
// ./src/modules/Superadmin/components/ManageDataBase/components/validate.js